
<template>
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.75 4.00008H2.91667M2.91667 4.00008H12.25M2.91667 4.00008L2.91667
      12.1667C2.91667 12.4762 3.03958 12.7729 3.25838 12.9917C3.47717
      13.2105 3.77391 13.3334 4.08333 13.3334H9.91667C10.2261 13.3334 10.522
       13.2105 10.7416 12.9917C10.9604 12.7729 11.0833 12.4762 11.0833 12.1667V4.00008M4.66667
       4.00008V2.83341C4.66667 2.524 4.78958 2.22725 5.00838 2.00846C5.22717 1.78966 5.52391
       1.66675 5.83333 1.66675H8.16667C8.47609 1.66675 8.77283 1.78966 8.99162 2.00846C9.21042
       2.22725 9.33333 2.524 9.33333 2.83341V4.00008M5.83333 6.91675V10.4167M8.16667 6.91675V10.4167"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>